import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, watch, onBeforeMount } from "vue";
import { useStore } from "vuex";
import Modal from "@/components/shared/Modal.vue";
import BorrowAmount from "@/components/loan-configuration/BorrowAmount.vue";
import LoanOptions from "@/components/loan-configuration/LoanOptions.vue";
import PgLoanOptionsModal from "@/components/professional-grad/PgLoanOptionsModal.vue";
import PelLoanOptions from "@/components/pel-loan-configuration/PelLoanOptions.vue";
import useApplicationData from "@/composables/useApplicationData";

interface Props {
  application: any;
  applicant: any;
  term?: string;
  initialDrawRequest?: any;
  loading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LocLoanConfigurationModal',
  props: {
    application: {},
    applicant: {},
    term: {},
    initialDrawRequest: {},
    loading: { type: Boolean }
  },
  emits: ["close", "complete", "updateBorrowAmount"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const PgLoanOptionsModalRef = ref<InstanceType<typeof PgLoanOptionsModal>>();

const store = useStore();

const props = __props;

const emit = __emit;

const activeStep = ref<number>(1);
const updatingBorrowAmount = ref<boolean>(false);

const { useProfessionalGradLoanOptionsModal, hasRepaymentBasedRates, isValidProfessionalGradFlow } =
  useApplicationData();

function closeModal() {
  emit("close");
}

function goBack() {
  if (activeStep.value === 2) {
    activeStep.value -= 1;
  }
}

function borrowAmountComplete(payload: { amount: number; requestedAmountChanged: boolean }) {
  if (payload.amount) {
    updatingBorrowAmount.value = true;
    emit("updateBorrowAmount", payload);
  } else {
    next();
  }
}

function complete(payload?: any) {
  if (activeStep.value === 1) {
    borrowAmountComplete(payload);
  } else {
    emit("complete", payload);
  }
}

function next() {
  if (activeStep.value < 2) {
    activeStep.value++;
  }
}

watch(
  () => updatingBorrowAmount.value,
  (newVal, oldVal) => {
    if (oldVal === true && newVal === false) {
      next();
    }
  },
);

onBeforeMount(() => {
  // check if school is undecided
  if (store.state.appData?.application?.schoolConfiguration?.schoolUndecided) {
    updatingBorrowAmount.value = false;
    activeStep.value = 2;
  }
});

__expose({
  updatingBorrowAmount,
	PgLoanOptionsModalRef,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(Modal, {
      class: "loan-configuration-modal",
      id: "loc-loan-configuration",
      closeBtn: true,
      onClose: closeModal
    }, {
      default: _withCtx(() => [
        (activeStep.value === 1)
          ? (_openBlock(), _createBlock(BorrowAmount, {
              key: 0,
              isCurrent: activeStep.value === 1,
              onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
              onComplete: complete,
              application: __props.application,
              loading: __props.loading || updatingBorrowAmount.value,
              initialDrawRequest: __props.initialDrawRequest,
              term: __props.term
            }, null, 8, ["isCurrent", "application", "loading", "initialDrawRequest", "term"]))
          : _createCommentVNode("", true),
        (activeStep.value === 2 && !_unref(isValidProfessionalGradFlow))
          ? (_openBlock(), _createBlock(LoanOptions, {
              key: 1,
              isCurrent: activeStep.value === 2,
              application: __props.application,
              applicant: __props.applicant,
              loading: __props.loading,
              initialDrawAmount: __props.initialDrawRequest?.amount,
              onPrevious: goBack,
              onComplete: complete,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
            }, null, 8, ["isCurrent", "application", "applicant", "loading", "initialDrawAmount"]))
          : _createCommentVNode("", true),
        (activeStep.value === 2 && _unref(isValidProfessionalGradFlow) && !_unref(hasRepaymentBasedRates))
          ? (_openBlock(), _createBlock(PelLoanOptions, {
              key: 2,
              loading: __props.loading,
              onPrevious: goBack,
              onComplete: complete
            }, null, 8, ["loading"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512), [
      [_vShow, 
      (activeStep.value <= 2 && !_unref(useProfessionalGradLoanOptionsModal)) ||
      (_unref(useProfessionalGradLoanOptionsModal) && activeStep.value === 1) ||
      !_unref(hasRepaymentBasedRates)
    ]
    ]),
    (activeStep.value === 2 && _unref(useProfessionalGradLoanOptionsModal))
      ? (_openBlock(), _createBlock(PgLoanOptionsModal, {
          key: 0,
          ref_key: "PgLoanOptionsModalRef",
          ref: PgLoanOptionsModalRef,
          onConfigurationComplete: complete,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
          closeBtn: true
        }, null, 512))
      : _createCommentVNode("", true)
  ], 64))
}
}

})